import { defineMessages } from 'react-intl';
import type { CoinbaseEngUsersAccountManagementApiApiAddress } from '@cbhq/identity-api-hooks/account-management/types';

export const ROUTE_TEAM = '/team';

// Wrapped in defineMessages so the i18n extractor includes it in messages.json.
// Shared by both invite trays to display the inline domain mismatch error.
const sharedMessages = defineMessages({
  domainMismatch: {
    id: 'Team.inviteTray.emailDomainMismatchError',
    defaultMessage: 'Invites must match your email domain ({domain})',
    description:
      "Inline error shown when an invite must match the logged-in user's email domain. The required domain is shown in parentheses",
  },
  domainMismatchFallback: {
    id: 'Team.inviteTray.emailDomainMismatchFallbackError',
    defaultMessage: 'Invites must match your email domain',
    description:
      "Inline error shown when an invite must match the logged-in user's email domain but the domain is unavailable",
  },
});

export const domainMismatchMessage = sharedMessages.domainMismatch;
export const domainMismatchFallbackMessage = sharedMessages.domainMismatchFallback;

export function getTeamMemberRoute(userUuid: string) {
  return `${ROUTE_TEAM}/member/${userUuid}`;
}

// MemberRole is now a string type to support dynamic roles from the backend.
// Role IDs follow the format: {product_id}/legal_entity:{role_id}
// It would nice to improve type safety here.
export type MemberRole = string;

export type MemberRoleMap = {
  label: string;
  name: string;
  description: string;
  value: MemberRole;
  productKey: string;
  /**
   * Whether this role can be offered in the invite/edit pickers. A member may
   * hold a role that is no longer assignable (e.g. off-flag coinbiz_admin); it's
   * still displayed but not selectable. Missing/true = assignable; false = not.
   */
  assignable: boolean;
};

export type Member = {
  userUuid: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: MemberRole[];
  avatarUrl?: string;
  address?: CoinbaseEngUsersAccountManagementApiApiAddress;
};
